var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreBenefitsUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.333 52.5V47.5C40.333 44.8478 39.2794 42.3043 37.4041 40.4289C35.5287 38.5536 32.9852 37.5 30.333 37.5H12.833C10.1808 37.5 7.6373 38.5536 5.76194 40.4289C3.88658 42.3043 2.83301 44.8478 2.83301 47.5V52.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.583 27.5C27.1059 27.5 31.583 23.0228 31.583 17.5C31.583 11.9772 27.1059 7.5 21.583 7.5C16.0602 7.5 11.583 11.9772 11.583 17.5C11.583 23.0228 16.0602 27.5 21.583 27.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.833 27.5L47.833 32.5L57.833 22.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsUserCheck);
export default __webpack_public_path__ + "static/media/core-benefits-user-check.11bce58f702ba270426a1a78946bf829.svg";
export { ForwardRef as ReactComponent };